import { isMicrosoftRing, parseIntOrNaN, } from '@office-start/config-query-wrapper-service';
import { getIsMobileOrTablet } from '@office-start/device-detection-utility';
var deleteSettingApiPath = '/deletesetting';
var deltaSyncApiPath = '/deltasync';
var edgeworthApiRootPath = '/recommended/api/beta/edgeworth';
var favoritesApiPath = '/favorites';
var favoritesItemsCount = 1000;
var hideApiPath = '/hide';
var periodicSyncIntervalInMin = 10;
var pinApiPath = '/pin';
var recentApiPath = '/recent';
var recentItemsCount = 15;
var reindexThresholdInDays = 15;
var tabFocusSyncThrottleWindowCount = 5;
var tabFocusSyncThrottleWindowInSeconds = 60;
var unhideApiPath = '/unhide';
var unpinApiPath = '/unpin';
var upsertSettingApiPath = '/upsertsetting';
export function resolveEdgeworthConfig(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var featureGates = _a.featureGates, featureSettings = _a.featureSettings, identity = _a.identity;
    var gates = featureGates.edgeworthConfigGates;
    // Feature Gates
    var backgroundSyncEnabled = (_b = gates === null || gates === void 0 ? void 0 : gates.edgeworthConfigBackgroundSyncEnabled) !== null && _b !== void 0 ? _b : false;
    var edgeworthS2SRecentEnabled = (_c = gates === null || gates === void 0 ? void 0 : gates.edgeworthConfigS2SRecentEnabled) !== null && _c !== void 0 ? _c : false;
    var taggingEnabled = (_d = gates === null || gates === void 0 ? void 0 : gates.edgeworthConfigTaggingEnabled) !== null && _d !== void 0 ? _d : false;
    var edgeworthTopicsEnabled = (_e = gates === null || gates === void 0 ? void 0 : gates.edgeworthConfigTopicsEnabled) !== null && _e !== void 0 ? _e : false;
    var playListsEnabled = (_f = gates === null || gates === void 0 ? void 0 : gates.edgeworthConfigPlayListsEnabled) !== null && _f !== void 0 ? _f : false;
    var userActionSortOrderEnabled = (_g = gates === null || gates === void 0 ? void 0 : gates.edgeworthConfigUserActionSortOrderEnabled) !== null && _g !== void 0 ? _g : false;
    var meetingObjectsEnabled = (_j = (_h = featureGates.edgeworthMeetingObjectsGates) === null || _h === void 0 ? void 0 : _h.edgeworthMeetingObjectsEnabled) !== null && _j !== void 0 ? _j : false;
    var quickAccessV1Enabled = (_l = (_k = featureGates.quickAccessV1Gates) === null || _k === void 0 ? void 0 : _k.quickAccessV1Enabled) !== null && _l !== void 0 ? _l : false;
    // Feature Settings
    var iceApplicationId = parseIntOrNaN((_o = (_m = featureSettings.sharedContext) === null || _m === void 0 ? void 0 : _m.recommendedIceApplicationId) !== null && _o !== void 0 ? _o : '-1');
    var substrateApiEndpoint = (_q = (_p = featureSettings.resources) === null || _p === void 0 ? void 0 : _p.substrate) !== null && _q !== void 0 ? _q : '';
    return {
        // Constants
        deleteSettingApiPath: deleteSettingApiPath,
        deltaSyncApiPath: deltaSyncApiPath,
        edgeworthApiRootPath: edgeworthApiRootPath,
        favoritesApiPath: favoritesApiPath,
        favoritesItemsCount: favoritesItemsCount,
        hideApiPath: hideApiPath,
        periodicSyncIntervalInMin: periodicSyncIntervalInMin,
        pinApiPath: pinApiPath,
        recentApiPath: recentApiPath,
        recentItemsCount: recentItemsCount,
        reindexThresholdInDays: reindexThresholdInDays,
        tabFocusSyncThrottleWindowCount: tabFocusSyncThrottleWindowCount,
        tabFocusSyncThrottleWindowInSeconds: tabFocusSyncThrottleWindowInSeconds,
        unhideApiPath: unhideApiPath,
        unpinApiPath: unpinApiPath,
        upsertSettingApiPath: upsertSettingApiPath,
        // Feature Gates
        backgroundSyncEnabled: backgroundSyncEnabled,
        edgeworthS2SRecentEnabled: edgeworthS2SRecentEnabled,
        taggingEnabled: taggingEnabled,
        edgeworthTopicsEnabled: edgeworthTopicsEnabled,
        meetingObjectsEnabled: meetingObjectsEnabled,
        playListsEnabled: playListsEnabled,
        settingApiEnabled: !getIsMobileOrTablet() && quickAccessV1Enabled,
        userActionSortOrderEnabled: userActionSortOrderEnabled,
        // Feature Settings
        EdgeworthMSITFeatureEnabled: isMicrosoftRing(featureSettings, identity),
        iceApplicationId: iceApplicationId,
        substrateApiEndpoint: substrateApiEndpoint,
    };
}
//# sourceMappingURL=resolveEdgeworthConfig.js.map